import * as stylex from "@stylexjs/stylex";
import "./seasons.stylex";
import { season } from "./seasons.stylex";
import "./tokens.stylex";
import { colors } from "./tokens.stylex";
import "./type.stylex";
import { type } from "./type.stylex";
export const summer = {
  x1b0foj6: "xjdw0yq x1b0foj6",
  $$css: true
};
export const fall = {
  x1b0foj6: "xtslg7x x1b0foj6",
  $$css: true
};
export const winter = {
  x1b0foj6: "xt1a8wu x1b0foj6",
  $$css: true
};
export const ambientType = {
  x138ayyd: "x108i80e x138ayyd",
  $$css: true
};